import { c as _c } from "react/compiler-runtime";
import styled, { css } from 'styled-components';
import Button from './base/Button';
import { StyledCard } from './base/Card';
import { IconName } from './base/Icon';
import Text from './base/Text';
import { Div } from './helpers/StyledUtils';
interface EmptyStateProps {
  title: string;
  description: string;
  asset: string;
  asset_position?: 'flex-start' | 'flex-end' | 'center' | 'background';
  cta: {
    icon: IconName;
    label: string;
    onClick?: () => void;
    to?: string;
  };
}
const StyledEmptyStateCard = styled(StyledCard)<{
  bg_url_asset?: string;
}>(({
  theme,
  bg_url_asset
}) => {
  const bg_asset = bg_url_asset || `empty_state_bg_${theme.mode}.svg`;
  const bg_url = `/images/empty/${bg_asset}`;
  return css`
    width: 840px;
    height: 472px;
    display: flex;
    align-self: center;
    border: ${theme.border};
    background-image: url(${bg_url});
    background-size: cover;
    background-position: end center;
    background-repeat: no-repeat;
  `;
});
export const StyledEmptyStateWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const EmptyState = t0 => {
  const $ = _c(26);
  const {
    title,
    description,
    cta,
    asset,
    asset_position: t1
  } = t0;
  const asset_position = t1 === undefined ? "center" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      align: "center",
      justify: "center",
      grow: true
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const t3 = asset_position === "background" ? asset : undefined;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      align: "center"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      x: 10
    };
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      b: 2
    };
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== title) {
    t7 = <Text bold={true} size="l" m={t6}>{title}</Text>;
    $[4] = title;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== description) {
    t8 = <Text muted={true}>{description}</Text>;
    $[6] = description;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== cta) {
    t9 = cta && <Button m={{
      t: 8
    }} primary={true} icon={cta.icon} to={cta.to} onClick={cta.onClick}>{cta.label}</Button>;
    $[8] = cta;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t10 = <Div w={50} flex={t4}><Div p={t5}>{t7}{t8}{t9}</Div></Div>;
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== asset_position) {
    t11 = {
      align: asset_position,
      justify: "center"
    };
    $[14] = asset_position;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== asset || $[17] !== asset_position) {
    t12 = asset_position !== "background" ? <img src={asset} /> : null;
    $[16] = asset;
    $[17] = asset_position;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] !== t11 || $[20] !== t12) {
    t13 = <Div w={50} flex={t11}>{t12}</Div>;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== t10 || $[23] !== t13 || $[24] !== t3) {
    t14 = <Div flex={t2}><StyledEmptyStateCard muted={true} bg_url_asset={t3}>{t10}{t13}</StyledEmptyStateCard></Div>;
    $[22] = t10;
    $[23] = t13;
    $[24] = t3;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
};
const StyledEmptyResultsCard = styled.div(({
  theme
}) => {
  const bg_url = `/images/empty/empty_gradient_${theme.mode}.svg`;
  return css`
    background-image: url(${bg_url});
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    width: 480px;
    height: 480px;
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(4)};
    justify-content: center;
    align-items: center;
    align-self: center;
  `;
});
export const EmptyResults = t0 => {
  const $ = _c(6);
  const {
    label,
    cta
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      align: "center",
      justify: "center"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== label) {
    t2 = <Text semi={true} muted={true} size="l">{label}</Text>;
    $[1] = label;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = cta || null;
  let t4;
  if ($[3] !== t2 || $[4] !== t3) {
    t4 = <Div flex={t1}><StyledEmptyResultsCard>{t2}{t3}</StyledEmptyResultsCard></Div>;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export default EmptyState;